module.exports = __webpack_public_path__ + "static/media/Columns.1ba1bd0c.svg";